import {FilterFieldResponseEnabled} from '../../../../common/services/responses/filter-field-response-enabled.model';
import {Directive, EventEmitter, Input, Output} from '@angular/core';
import {FilterFieldCustomEnabled} from '../../../../common/services/responses/filter-field-custom-enabled.model';

@Directive()
export class FilterEnableComponent {
  @Input() fields: FilterFieldResponseEnabled[] | FilterFieldCustomEnabled[] = [];
  @Output() onFilterRaz: EventEmitter<FilterFieldResponseEnabled | FilterFieldCustomEnabled> = new EventEmitter<FilterFieldResponseEnabled | FilterFieldCustomEnabled>();
  getToolTipButtonFilter(filter: FilterFieldResponseEnabled) {
    return `enlever ce filtre "${filter.label}"`;
  }
  getValue(filter: FilterFieldResponseEnabled | FilterFieldCustomEnabled) {
    throw new Error('not Implemented');
  }
  reinitFilters() {
    this.onFilterRaz.emit(null);
  }
  reinitFilter(filter) {
    this.onFilterRaz.emit(filter);
  }
}
